module.exports = "https://web-assets.ifttt.com/packs/media/icons/icon-info-66f8dc8a.svg";